import type { HostedFieldsTokenizePayload } from 'braintree-web';

/** Alias for braintree hosted fields type */
export type PaymentMethod = HostedFieldsTokenizePayload;

export type CustomerPaymentTypes = {
  net_terms: boolean;
  braintree_payments: boolean;
};

/** Defined on order-api cart submit endpoint */
export type PaymentType =
  | 'net_terms'
  | 'credit_card'
  | 'apple_pay'
  | 'wholly_gift_certificate'
  | 'deferred_labworks';
